export default __webpack_public_path__ + "static/media/caret-up.2bbe4c91.png";